module.exports = __webpack_public_path__ + "img/france.a7d33e19.png";